import { render, staticRenderFns } from "./SegmentedControl.vue?vue&type=template&id=a9022c28"
import script from "./SegmentedControl.vue?vue&type=script&lang=ts"
export * from "./SegmentedControl.vue?vue&type=script&lang=ts"
import style0 from "./SegmentedControl.vue?vue&type=style&index=0&id=a9022c28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports